import { ANALYTICS_GOALS } from '@/shared/constants';
import type { AnalyticsGoal } from '@/shared/types';

const ANALYTICS_GOAL_VALUES = new Set<string>(Object.values(ANALYTICS_GOALS));

export function isAnalyticsGoal(value: string): value is AnalyticsGoal {
    return ANALYTICS_GOAL_VALUES.has(value);
}
